import { render, staticRenderFns } from "./dynamic-route.vue?vue&type=template&id=4e7c48e4&"
import script from "./dynamic-route.vue?vue&type=script&lang=js&"
export * from "./dynamic-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports